import axios from 'lib/axios';

const physicalPayment = async (values) => {
  const { body, orderId } = values;
  const { data } = await axios.post(`/v2/payment/${orderId}/done`, body);
  return data;
};

const getCustomerPayments = async (id) => {
  const { data } = await axios.get(`/v2/payment/customer/${id}`);
  return data;
};

const getOrderById = async (id) => {
  const { data } = await axios.get(`/v2/payment/order/${id}`);
  return data;
};

export { physicalPayment, getCustomerPayments, getOrderById };
